import { useEffect } from 'react';
import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import {
  toBackendLang,
  withServerErrorCode,
} from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import ErrorTemplate from '../ErrorTemplate';

const messages = defineMessages({
  altText: {
    id: 'Sorry, but this page does not exist…',
    defaultMessage: 'Sorry, but this page does not exist…',
  },
});

/**
 * Not found function.
 * @function NotFound
 * @returns {string} Markup of the not found page.
 */
const NotFound = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.intl.locale);
  const intl = useIntl();

  useEffect(() => {
    dispatch(
      getNavigation(
        config.settings.isMultilingual ? `/${toBackendLang(lang)}` : '/',
        config.settings.navDepth,
      ),
    );
  }, [dispatch, lang]);

  return (
    <ErrorTemplate
      imageSrc="/errors/error404.png"
      imageAlt={intl.formatMessage(messages.altText)}
      title={
        <FormattedMessage
          id="Sorry, but this page does not exist…"
          defaultMessage="Sorry, but this page does not exist…"
        />
      }
      description={
        <>
          <p className="text-up-01 text-sm-up-02">
            <FormattedMessage
              id="We apologize for the inconvenience, but the page you were trying to access is not at this address."
              defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not at this address."
            />
          </p>
          <p className="text-up-01 text-sm-up-02">
            <FormattedMessage
              id="If you are sure the address is correct but encounter an error, please contact the {siteAdmin}."
              defaultMessage="If you are sure the address is correct but encounter an error, please contact the {siteAdmin}."
              values={{
                siteAdmin: (
                  <Link className="text-bold" to="/contact-form">
                    <FormattedMessage
                      id="site administration"
                      defaultMessage="site administration"
                    />
                  </Link>
                ),
              }}
            />
          </p>
          <p className="text-up-01 text-sm-up-02">
            <FormattedMessage id="Thank you." defaultMessage="Thank you." />
          </p>
        </>
      }
    />
  );
};

export default withServerErrorCode(404)(NotFound);
